import { useEffect } from "react";
import { GHL_FORM_ID, GHL_FORM_SRC, GHL_EMBED_SCRIPT } from "@/data/site";

const LeadForm = () => {
  useEffect(() => {
    if (!document.querySelector(`script[src="${GHL_EMBED_SCRIPT}"]`)) {
      const s = document.createElement("script");
      s.src = GHL_EMBED_SCRIPT;
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <div
      data-testid="lead-form-wrapper"
      className="overflow-hidden rounded-md border border-black/10 bg-white shadow-[0_24px_60px_rgba(20,23,25,0.10)]"
    >
      <div className="border-b border-black/5 bg-bear-ink px-6 py-4">
        <p className="font-head text-xs font-bold uppercase tracking-[0.24em] text-bear-cyan">
          Fast Form Fill
        </p>
        <p className="mt-1 font-display text-2xl tracking-wide text-white">
          BOOK YOUR SERVICE
        </p>
      </div>
      <iframe
        src={GHL_FORM_SRC}
        style={{ width: "100%", height: "100%", minHeight: "630px", border: "none", borderRadius: "6px" }}
        id={`inline-${GHL_FORM_ID}`}
        data-layout="{'id':'INLINE'}"
        data-trigger-type="alwaysShow"
        data-trigger-value=""
        data-activation-type="alwaysActivated"
        data-activation-value=""
        data-deactivation-type="neverDeactivate"
        data-deactivation-value=""
        data-form-name="Contact Us"
        data-height="630"
        data-layout-iframe-id={`inline-${GHL_FORM_ID}`}
        data-form-id={GHL_FORM_ID}
        data-cookie-consent="true"
        data-cookie-consent-provider="auto"
        title="Contact Us"
        data-testid="lead-form-iframe"
      />
    </div>
  );
};

export default LeadForm;
